import NotReviewedCell from './container';

export default NotReviewedCell;
